// แถวคนหนึ่งคน — ใช้ทั้งแผง "ผู้เข้าถึง" และหน้า Setting → Staff
//
// วางไว้ใน component เดียวเพื่อให้สองที่หน้าตาเหมือนกันจริง ไม่ใช่ markup คนละชุด
// ที่บังเอิญคล้ายกันแล้วค่อย ๆ เพี้ยนออกจากกัน
//
// ผู้เรียกเป็นคนใส่ code-chip กับปุ่มท้ายแถวเอง เพราะสองที่ต้องการไม่เหมือนกัน
import { cn } from "@shared/lib/utils";
import { PersonAvatar } from "@shared/ui/person-avatar";
import { initialOf, type PersonView, primaryName } from "../lib/person-view";

/** แผนก | รูป | ชื่อไทย+อังกฤษ(ชื่อเล่น) / ตำแหน่งตัวเล็กบรรทัดล่าง */
export function PersonCell({ v }: { v: PersonView }) {
  // ไม่มีชื่อไทยก็ให้ชื่ออังกฤษขึ้นเป็นชื่อหลัก — ไม่ต้องโชว์ซ้ำสองที่
  const primary = primaryName(v);
  const secondary = v.thai && v.eng ? v.eng : "";
  return (
    <>
      {/* แผนกเป็นคอลัมน์แรกสุด ก่อนรูป — ไล่สายตาจากขอบซ้ายก็เห็นว่ากลุ่มไหนเริ่มตรงไหน */}
      <span className={cn("mem-dept", !v.department && "mem-dept-none")}>
        {v.department || "ไม่ระบุแผนก"}
      </span>
      <PersonAvatar url={v.photo} initial={initialOf(v)} size="sm" />
      <span className="mem-person grow">
        {/* เว้นวรรคจริงคั่นไว้ ไม่พึ่ง margin อย่างเดียว — ไม่งั้นก๊อปชื่อออกไปจะติดกันเป็นคำเดียว */}
        <span className="mem-name">
          {primary}
          {secondary && (
            <>
              {" "}
              <span className="mem-name-en">{secondary}</span>
            </>
          )}
          {v.nick && (
            <>
              {" "}
              <span className="mem-nick">({v.nick})</span>
            </>
          )}
        </span>
        {v.position && <span className="mem-meta">{v.position}</span>}
      </span>
    </>
  );
}
